<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/158qWDS/tc-custom/9781440586569.jpg?1718106263653" alt="This image is the cover for the book Choose Your Retirement"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Choose Your Retirement
      </h1>
      <p class="bookDescription body article font2">
        <b>As seen in <i>Woman's Day</i>, <i>US News &amp; World Report</i>, and <i>Money Magazine</i></b><br/><br/><b>Uncover the truth about planning for retirement!</b><br/><br/>From financial advisors and pundits on television to colleagues and family members, everyone has something to say about retirement. But how much of it is true? Whether you're looking to move into a senior living community or travel the world, <i>Choose Your Retirement</i> shows you how to realistically prepare for the future you desire. Inside, you will find expert advice for choosing the best retirement path for you and your family as well as information on common myths like:<br/><br/>-You will only need 80 percent of your current income in retirement<br/><br/>-Medicare will cover all your health-care needs<br/><br/>-Switching investments over to bonds is the safest retirement option<br/><br/>-Social Security will run out in 2033, leaving millions without their promised benefits<br/><br/>Filled with hundreds of facts about retiring, <i>Choose Your Retirement</i> helps you set attainable financial goals and plan for the retirement—and life—you've always wanted.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emily Guy Birken
      </h2>
      
      <p class="authorDescription body article">Emily Guy Birken is a finance writer who writes the &ldquo;Live Like a Mensch&rdquo; column for&#160;<I>The Dollar Stretcher</I>. She is also a contributor to&#160;<I>Wise Bread</I>,&#160;<I>PT Money</I>,&#160;<I>Money Crashers</I>,&#160;<I>Yahoo! Finance</I>, and&#160;<I>Business Insider</I>, and many other personal finance sites. She edits and writes for the <I>FinCon</I> blog, an annual conference for financial bloggers. She is the author of&#160;<I>The 5 Years Before You Retire</I>,&#160;<I>Choose Your Retirement</I>,&#160;<I>Making Social Security Work for You</I>, and&#160;<I>End Financial Stress Now</I>. You can visit her at SAHMnambulist.blogspot.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cbcd6be